import React from "react";
import "../assets/stylesheets/xml.css"

export const XMLViewer = ({content, small = true} : { content: string, small?: boolean}) => {
    return(<pre className="xml-content xml-border" style={{maxHeight: small ? "400px" : undefined}}>{content}</pre>)
}